import { NgModule } from "@angular/core";

import { FeatherIconDirective } from "@core/directives/core-feather-icons/core-feather-icons";
import { RippleEffectDirective } from "@core/directives/core-ripple-effect/core-ripple-effect.directive";
import { DisableNumberInputScroll } from "./disable-number-input-scroll/disable-number-input-scroll";
import { LoveItNgSelectDirective } from "./love-it-ng-select/love-it-ng-select.directive";
import { EmptyRowDirective } from "./empty-row/empty-row.directive";

@NgModule({
  declarations: [
    RippleEffectDirective,
    FeatherIconDirective,
    DisableNumberInputScroll,
    LoveItNgSelectDirective,
    EmptyRowDirective,
  ],
  exports: [
    RippleEffectDirective,
    FeatherIconDirective,
    DisableNumberInputScroll,
    LoveItNgSelectDirective,
    EmptyRowDirective,
  ],
})
export class CoreDirectivesModule {}
